export default "__VITE_ASSET__BVSqKR$5__"